import React, { useState } from 'react';
import { Phone, MapPin, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const scrollToSection = (id: string) => {
    setIsMenuOpen(false);
    if (id === 'top') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  const navLinks = [{
    name: 'Inicio',
    id: 'top'
  }, {
    name: 'Nosotros',
    id: 'ventaja'
  }, {
    name: 'Beneficios',
    id: 'beneficios'
  }, {
    name: 'Equipo',
    id: 'equipo'
  }, {
    name: 'Preguntas',
    id: 'faq'
  }, {
    name: 'Contacto',
    id: 'contacto'
  }];
  return <header className="sticky top-0 z-50 w-full bg-navy text-white shadow-md" data-id="element-169">
      <div className="container mx-auto px-4 py-3 flex justify-between items-center" data-id="element-170">
        {/* Logo */}
        <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('top')} data-id="element-171">
          <img src="https://cdn.magicpatterns.com/uploads/5T16zCVHXm8iCRBeXBiqc1/Logo_de_angel_insurance_con_Dorado_claro_Este_si.png" alt="Angel Insurance Logo" className="h-12 object-contain" data-id="element-172" />
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center gap-6 lg:gap-8 text-sm font-medium" data-id="element-173">
          <nav className="flex items-center gap-6" data-id="element-174">
            {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.id)} className="hover:text-gold transition-colors" data-id="element-175">
                {link.name}
              </button>)}
          </nav>

          <div className="h-6 w-px bg-white/20" data-id="element-176"></div>

          <a href="tel:8134034867" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-177">
            <Phone size={18} className="text-gold" data-id="element-178" />
            <span className="font-semibold" data-id="element-179">(813) 403-4867</span>
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden p-2 text-white hover:text-gold transition-colors" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-180">
          {isMenuOpen ? <X size={28} data-id="element-181" /> : <Menu size={28} data-id="element-182" />}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      <AnimatePresence data-id="element-183">
        {isMenuOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="md:hidden overflow-hidden bg-navy border-t border-white/10" data-id="element-184">
            <div className="container mx-auto px-4 py-6 flex flex-col gap-6" data-id="element-185">
              <nav className="flex flex-col gap-4 text-center text-lg" data-id="element-186">
                {navLinks.map(link => <button key={link.name} onClick={() => scrollToSection(link.id)} className="hover:text-gold transition-colors py-2" data-id="element-187">
                    {link.name}
                  </button>)}
              </nav>

              <div className="h-px w-full bg-white/10 my-2" data-id="element-188"></div>

              <div className="flex flex-col items-center gap-4 text-sm" data-id="element-189">
                <a href="tel:8134034867" className="flex items-center gap-2 hover:text-gold transition-colors" data-id="element-190">
                  <Phone size={20} className="text-gold" data-id="element-191" />
                  <span className="font-semibold text-lg" data-id="element-192">(813) 403-4867</span>
                </a>
                <div className="flex items-center gap-2 text-gray-300" data-id="element-193">
                  <MapPin size={20} className="text-gold" data-id="element-194" />
                  <span data-id="element-195">3840 W Humphrey St, Tampa, FL</span>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}